module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Legendary Locals of Huntsville Alabama")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-head2",
    attrs: {
      "id": "Intro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("INTRODUCTION")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Nestled in the Tennessee Valley, in the drainage basin of the Tennessee River and surrounded by mountains associated with the Cumberland Plateau, Huntsville boasts a yearly canvas of seasonal color and breathtaking natural beauty as varied as the individuals who made and continue to make it the shining star of North Alabama. Huntsville, the county seat of Madison, is constantly named one of the most desirable cities in which to live, to do business, and to raise a family.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("From its beginnings as a contested land between two Indian tribes to the pioneering spirit of its settlers, through siege during the Civil War to its steady evenness, and even growth, during the Great Depression, the spirit of Huntsvillians has never waned. Following a period during which cotton was king and the city had a number of functioning, prosperous mills, Huntsville landed on the national map when the federal government located a munitions plant here. Comprising over 38,000 acres, Redstone Arsenal today employees over 35,000 individuals and is home to NASA’s Marshall Space Flight Center, the US Missile Defense Agency, the US Army Aviation and Missile Command, and the headquarters of the US Army Materiel Command, among other organizations.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Huntsville is home to a number of technological endeavors that have made an impact on the national and international scene, including Sanmina Defense and Aerospace, Adtran, and HudsonAlpha Institute for Biotechnology.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But the Rocket City is not one-sidedly technological. Its locals have always valued both education and the arts, and it boasts several highly regarded institutions of higher learning, as well as countless arts organizations, including an arts council, a symphony, and a ballet company. Two of the mills have been transformed—one into a performing arts center and the other into an arts and entertainment center, the largest of its kind in the Southeast.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Throughout its evolution, Huntsville remains a town of constant innovation, transition, and transformation, while maintaining its grace and friendliness with a touch of charm and a dash of pride as modest as the house John Hunt built under a bluff near the Big Spring in 1805.")])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/FM-F3.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Downtown Huntsville")])]), _c('br'), _vm._v("Downtown Huntsville is seen in this south-facing photograph taken from the top of the Russel Erskine Hotel. In the background is Monte Sano Mountain. (Photograph by the author.)")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7537d72c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 81
// module chunks = 0